import client from "./axiosConfig";

export const postProject = (data) => {
  const config = {
    url: "/projects/",
    method: "POST",
    data,
  };
  const response = client(config);
  return response;
};

export const getProjects = (params) => {
  const config = {
    url: "/projects/",
    method: "GET",
    params
  };
  const response = client(config);
  return response;
};

export const getProjectDetails  = (id, params) => {
  const config = {
    url: `/projects/${id}/`,
    method: "GET",
    params
  };
  const response = client(config);
  return response;
} 

export const getProjectUsers = (projectId, params={}) => {
  const config = {
    url: `/projects/${projectId}/users/`,
    method: "GET",
    params,
  };
  const response = client(config);
  return response;  
}

export const uploadProjectUsers = (projectId, file) => {
  const formData = new FormData();
  formData.append("file", file);
  const config = {
    url: `/projects/${projectId}/project-users-excel/`,
    method: "POST",
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  };
  const response = client(config);
  return response;  
}  

export const deleteProjectUser = (projectId, userId) => {
  const config = {
    url: `/projects/${projectId}/users/${userId}/`,
    method: "DELETE",
  }
  const response = client(config);
  return response;
}

export const updateProjectUser = (projectId, userId, data) => {
  const config = {
    url: `/projects/${projectId}/users/${userId}/`,
    method: "PATCH",
    data
  }
  const response = client(config);
  return response;
}

export const updateProjectDetails = (projectId, data) => {
  const config = {
    url: `/projects/${projectId}/`,
    method: "PATCH",
    data
  }
  const response = client(config);
  return response;
}

export const getProjectSites = (projectId, params) => {
  const config = {
    url: `/projects/sites/`,
    method: "GET",
    params: {
      project: projectId,
      ...params
    }
  };
  const response = client(config);
  return response;
};

export const getProjectFiles = (projectId, params) => {
  const config = {
    url: `/projects/${projectId}/files/`,
    method: "GET",
    params,
  };
  return client(config);
};

export const uploadProjectFile = (projectId, data) => {
  const config = {
    url: `/projects/${projectId}/files/`,
    method: "POST",
    data,
  };
  return client(config);
};

export const deleteProjectFile = (projectId, fileId) => {
  const config = {
    url: `/projects/${projectId}/files/${fileId}/`,
    method: "DELETE",
  };
  return client(config);
};

export const addProjectUser = (projectId, data) => {
  const config = {
    url: `/projects/${projectId}/users/`,
    method: "POST",
    data
  };
  return client(config);
}

export const bulkDeleteProjectUsers = (projectId, userIds) => {
  const config = {
    url: `/projects/${projectId}/users/bulk-remove/`,
    method: "DELETE",
    data: { ids: userIds },
  };
  return client(config);
};
